import script from "./CompanionRotate.vue?vue&type=script&lang=ts&setup=true"
export * from "./CompanionRotate.vue?vue&type=script&lang=ts&setup=true"

import "./CompanionRotate.vue?vue&type=style&index=0&id=34a9fc24&lang=stylus&scoped=true"

import exportComponent from "/codebuild/output/src462465770/src/2022-meta-acrossthemetaverse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a9fc24"]])

export default __exports__